module.exports = __webpack_public_path__ + "media/images/company-logos/escap-logo-dca21d538231f415b803568e789dbb27.jpg";